(function () {
  'use strict';

  var inflight = false;

  function getController() {
    return document.querySelector('.luggage-drop-controller');
  }

  function getHandle() {
    return document.querySelector('.luggage-drop-controller__handle');
  }

  function getTrack() {
    return document.querySelector('.luggage-drop-controller__track');
  }

  function getThemeCount() {
    var handle = getHandle();
    return handle ? parseInt(handle.dataset.themeCount, 10) : 1;
  }

  function getIconPctForIndex(index) {
    var btns  = getIconButtons();
    var btn   = btns[index];
    var track = getTrack();
    if (!btn || !track) {
      var total = getThemeCount();
      if (total <= 1) return 0;
      return (index / (total - 1)) * 100;
    }
    var btnRect   = btn.getBoundingClientRect();
    var trackRect = track.getBoundingClientRect();
    var btnCenter = btnRect.left + btnRect.width / 2;
    var pct       = ((btnCenter - trackRect.left) / trackRect.width) * 100;
    return Math.min(100, Math.max(0, pct));
  }

  function nearestIndexForClientX(clientX) {
    var btns  = getIconButtons();
    var best  = 0;
    var bestDist = Infinity;
    btns.forEach(function (btn, i) {
      var rect   = btn.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var dist   = Math.abs(clientX - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  function moveHandle(index, animate) {
    var handle = getHandle();
    if (!handle) return;
    var pct = getIconPctForIndex(index);
    if (!animate) handle.style.transition = 'none';
    handle.style.left = pct + '%';
    if (!animate) {
      handle.offsetWidth;
      handle.style.transition = '';
    }
  }

  function getIconButtons() {
    return document.querySelectorAll('[data-theme-handle][data-theme-index]');
  }

  function updateActiveIcon(targetHandle) {
    getIconButtons().forEach(function (btn) {
      var isActive = btn.dataset.themeHandle === targetHandle;
      btn.classList.toggle('luggage-drop-hero__icon-btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function getSectionKeys() {
    var keys = [];
    document.querySelectorAll('[data-ldrop-theme-target="true"]').forEach(function (el) {
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (!wrapper) return;
      var key = wrapper.id.replace('shopify-section-', '');
      if (keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  function getActiveHandle() {
    var controller = getController();
    return controller ? controller.dataset.activeTheme : null;
  }

  function swap(targetHandle, targetUrl, targetIndex, push) {
    if (inflight) return;
    var keys = getSectionKeys();
    if (!keys.length) return;

    inflight = true;
    document.documentElement.setAttribute('data-ldrop-loading', 'true');

    moveHandle(targetIndex, true);
    updateActiveIcon(targetHandle);

    fetch(targetUrl + '?sections=' + keys.join(','), {
      method: 'GET',
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        Object.keys(data).forEach(function (key) {
          var html = data[key];
          if (html == null) return;
          var wrapper = document.getElementById('shopify-section-' + key);
          if (wrapper) wrapper.innerHTML = html;
        });

        /* Re-position handle after DOM replacement — no animation,
           handle was already animated before the fetch */
        moveHandle(targetIndex, false);
        reinitInfiniteOptions();
        document.dispatchEvent(new CustomEvent('ldrop:swap-complete'));

        if (push) {
          history.pushState(
            { ldropTheme: targetHandle, ldropIndex: targetIndex, url: targetUrl },
            '',
            targetUrl
          );
        }
      })
      .catch(function (err) {
        console.warn('[ldrop-controller] swap failed', err);
        var prevHandle = getActiveHandle();
        var prevBtn    = prevHandle
          ? document.querySelector('[data-theme-handle="' + prevHandle + '"]')
          : null;
        var prevIndex  = prevBtn ? parseInt(prevBtn.dataset.themeIndex, 10) : 0;
        moveHandle(prevIndex, true);
        updateActiveIcon(prevHandle);
      })
      .finally(function () {
        inflight = false;
        document.documentElement.removeAttribute('data-ldrop-loading');
      });
  }

  function getThemeMap() {
    var controller = getController();
    if (!controller || !controller.dataset.themeMap) return null;
    try { return JSON.parse(controller.dataset.themeMap); } catch (e) { return null; }
  }

  function getBtnByIndex(index) {
    var btns = getIconButtons();
    return btns[index] || null;
  }

  function getThemeDataByIndex(index) {
    var map = getThemeMap();
    if (map && map[index]) return map[index];
    var btn = getBtnByIndex(index);
    if (!btn) return null;
    return { handle: btn.dataset.themeHandle, url: btn.dataset.themeUrl, index: index };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-handle][data-theme-index]');
    if (!btn) return;
    e.preventDefault();

    var idx   = parseInt(btn.dataset.themeIndex, 10);
    var theme = getThemeDataByIndex(idx);
    if (!theme) return;

    var activeHandle = getActiveHandle();
    if (theme.handle === activeHandle || inflight) return;

    swap(theme.handle, theme.url, idx, true);
  });

  document.addEventListener('click', function (e) {
    var track = e.target.closest('.luggage-drop-controller__track');
    if (!track || e.target.closest('.luggage-drop-controller__handle')) return;

    var idx   = nearestIndexForClientX(e.clientX);
    var theme = getThemeDataByIndex(idx);
    if (!theme) return;

    var activeHandle = getActiveHandle();
    if (theme.handle === activeHandle || inflight) return;

    swap(theme.handle, theme.url, idx, true);
  });

  (function () {
    var dragging  = false;
    var dragHandle = null;
    var dragTrack  = null;

    document.addEventListener('mousedown', function (e) {
      var h = e.target.closest('.luggage-drop-controller__handle');
      if (!h) return;
      e.preventDefault();
      dragging   = true;
      dragHandle = h;
      dragTrack  = h.closest('.luggage-drop-controller__track');
      dragHandle.style.transition = 'none';
      dragHandle.classList.add('ldrop-interacted');
    });

    document.addEventListener('touchstart', function (e) {
      var h = e.target.closest('.luggage-drop-controller__handle');
      if (!h) return;
      dragging   = true;
      dragHandle = h;
      dragTrack  = h.closest('.luggage-drop-controller__track');
      dragHandle.style.transition = 'none';
      dragHandle.classList.add('ldrop-interacted');
    }, { passive: true });

    function onMove(clientX) {
      if (!dragging || !dragTrack) return;
      var rect = dragTrack.getBoundingClientRect();
      var pct  = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      dragHandle.style.left = pct + '%';
    }

    function onRelease(clientX) {
      if (!dragging) return;
      dragging = false;
      dragHandle.style.transition = '';

      var idx   = nearestIndexForClientX(clientX);
      var theme = getThemeDataByIndex(idx);
      if (!theme) return;

      var activeHandle = getActiveHandle();
      if (theme.handle === activeHandle) {
        moveHandle(idx, true);
        return;
      }
      swap(theme.handle, theme.url, idx, true);
    }

    document.addEventListener('mousemove', function (e) { onMove(e.clientX); });
    document.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('mouseup',   function (e) { onRelease(e.clientX); });
    document.addEventListener('touchend',  function (e) { onRelease(e.changedTouches[0].clientX); });
  })();

  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.ldropTheme) return;
    swap(e.state.ldropTheme, e.state.url, e.state.ldropIndex || 0, false);
  });

  function reinitInfiniteOptions() {
    var c = document.getElementById('infiniteoptions-container');
    if (!c) return;
    var productEl = document.querySelector('[data-featured-product-json]');
    if (productEl) {
      try { window.shoppadProductJSON = JSON.parse(productEl.dataset.featuredProductJson); } catch (e) {}
    }
    var api = window.Shoppad?.apps?.infiniteoptions;
    if (typeof api?.init === 'function') { try { api.init(); } catch (e) {} }
  }

  function init() {
    var handle = getHandle();
    if (!handle) return;

    moveHandle(parseInt(handle.dataset.activeIndex, 10) || 0, false);

    if (!document.getElementById('ldrop-bg-transition')) {
      var s       = document.createElement('style');
      s.id        = 'ldrop-bg-transition';
      s.textContent = 'body { transition: background-color 400ms ease; }';
      document.head.appendChild(s);
    }

    var controller   = getController();
    var activeHandle = controller && controller.dataset.activeTheme;
    if (activeHandle && !history.state) {
      history.replaceState(
        { ldropTheme: activeHandle, ldropIndex: parseInt(handle.dataset.activeIndex, 10) || 0, url: window.location.pathname },
        '',
        window.location.href
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
